import React, { Component } from 'react'
import { Link } from 'react-router'
import Logo from '../../../components/Logo'
import SignInLink from '../../../components/SignInLink'
import './HomeNav.scss'

class HomeNav extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const links = this.props.links.map((item, index) => {
          return (<li><Link to={`#${item.section}`}>{item.label}</Link></li>)
        })
        return (
            <div className='home-nav'>
              <div className='container'>
                  <Link to='/'><Logo></Logo></Link>
                  <div className='row'>
                    <div className='col-xs-2 col-sm-8'>
                      <ul className='hidden-xs  list-unstyled list-inline text-right'>
                        {links}
                      </ul>
                    </div>
                    <div className='col-xs-4 col-xs-offset-1 col-sm-offset-0 col-sm-2'>
                      <Link to='login' className="btn btn-success btn-lg btn-block">Login</Link>
                    </div>
                    <div className='col-xs-5 col-sm-2'>
                      <Link to='register' className="btn btn-info btn-lg btn-block">Register</Link>
                    </div>
                  </div>
                </div>
            </div>
        )
    }
}

export default HomeNav



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeNav/index.js